<template>
  <div class="flow-editor">
    <div v-if="form" class="flow-editor__inner">
      <SidebarGeneral
        :form="form"
        :activePageIndex="activePageIndex"
        :activeEndingPageIndex="activeEndingPageIndex"
        :pageType="activeEndingPage ? 'ending' : 'page'"
      />

      <div class="form-editor-wrap">
        <FormEditor
          :activePage="activePage"
          :activeEndingPage="activeEndingPage"
          :activeElementIndex="activeElementIndex"
          @set-active-element="setActiveElement"
          @remove-element="removeElement"
          @add-new-input="setActiveElement(null)"
          @open-page-settings="openPageSettings"
        />
        <FormPages
          :form="form"
          :activePageIndex="activePageIndex"
          :activeEndingPageIndex="activeEndingPageIndex"
          @set-active-page="setActivePage"
          @set-active-ending-page="setActiveEndingPage"
        />
      </div>
      <SidebarElement
        v-if="activeElement"
        :element="activeElement"
        :pageType="activeEndingPage ? 'ending' : 'page'"
      />

      <SidebarPage v-if="formStore.showPageSettings" :activePage="activePage" />
    </div>
    <div v-else class="flow-editor__loading">
      <LoadingSpinner size="xl" color="dark" />
    </div>
  </div>
</template>

<script>
  import { ref, watchEffect, computed, onMounted, onUnmounted } from 'vue';
  import { useRoute } from 'vue-router';
  import { useFormStore } from '@/store/formStore';

  import SidebarGeneral from '@/components/editor/sidebar/general/SidebarGeneral.vue';
  import FormEditor from '@/components/editor/FormEditor.vue';
  import FormPages from '@/components/editor/FormPages.vue';
  import SidebarElement from '@/components/editor/sidebar/elements/SidebarElement.vue';
  import SidebarPage from '@/components/editor/sidebar/page/SidebarPage.vue';
  import LoadingSpinner from '@/components/partials/LoadingSpinner.vue';
  export default {
    components: {
      SidebarGeneral,
      FormEditor,
      FormPages,
      SidebarElement,
      SidebarPage,
      LoadingSpinner,
    },
    setup() {
      const route = useRoute();
      const formStore = useFormStore();
      const form = ref(null);

      watchEffect(() => {
        if (route.params.id) {
          formStore.loadForm(route.params.id).then(() => {
            form.value = formStore.currentForm;
            if (form.value.pages.length > 0) {
              formStore.setActivePage(0); // Set the first page as active by default
            }
          });
        }
      });

      const activePage = computed(() => formStore.activePage);
      const activeEndingPage = computed(() => formStore.activeEndingPage);
      const activePageIndex = computed(() => formStore.activePageIndex);
      const activeEndingPageIndex = computed(() => formStore.activeEndingPageIndex);
      const activeElementIndex = computed(() => formStore.activeElementIndex);
      const activeElement = computed(() => formStore.activeElement);

      const setActivePage = (pageIndex) => {
        formStore.setActivePage(pageIndex);
      };

      const setActiveEndingPage = (pageIndex) => {
        formStore.setActiveEndingPage(pageIndex);
      };

      const removeElement = (elementIndex) => {
        formStore.removeElement(elementIndex);
      };

      const setActiveElement = (elementIndex) => {
        formStore.setActiveElementIndex(elementIndex);
      };

      const openPageSettings = () => {
        formStore.setShowPageSettings(true);
      };

      return {
        form,
        activePage,
        activeEndingPage,
        activePageIndex,
        activeEndingPageIndex,
        activeElementIndex,
        activeElement,
        formStore,
        setActivePage,
        setActiveEndingPage,
        removeElement,
        setActiveElement,
        openPageSettings,
      };
    },
  };
</script>

<style scoped lang="scss">
  .flow-editor {
    // display: flex;
    flex-grow: 1;
    overflow: auto;
    width: 100%;
    &__inner {
      display: flex;
      width: 100%;
      height: 100%;
    }
    &__loading {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 100%;
      width: 100%;
    }
    .form-editor-wrap {
      flex: 1;
      display: flex;
      justify-content: center;
      height: 100%;
      overflow-y: auto;
      flex-direction: column;
    }
  }
</style>
